import React, { createContext, useState } from 'react';

type GoalType = {
  goals: string;
}

type PropsGoalContext = {
  stateGoal: GoalType;
  setStateGoal: React.Dispatch<React.SetStateAction<GoalType>>;
}

const DEFAULT_VALUE = {
  stateGoal: {
    goals: ""
  },
  setStateGoal: () => { }
}

const GoalContext = createContext<PropsGoalContext>(DEFAULT_VALUE);

const GoalContextContextProvider = ({ children }: any) => {
  const [stateGoal, setStateGoal] = useState(DEFAULT_VALUE.stateGoal)

  return (
    <GoalContext.Provider value={{ stateGoal, setStateGoal }}>
      {children}
    </GoalContext.Provider>
  )
}

export { GoalContextContextProvider };
export default GoalContext